import React from 'react';
import arrayMutators from 'final-form-arrays';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { Form, UnsavedChangesWrapper } from '../../components';
import EditListingDescriptionPageOne from './EditListingDescriptionPages/EditListingDescriptionPageOne';
import EditListingDescriptionPageTwo from './EditListingDescriptionPages/EditListingDescriptionPageTwo';
import EditListingDescriptionPageThree from './EditListingDescriptionPages/EditListingDescriptionPageThree';
import EditListingDescriptionPageFour from './EditListingDescriptionPages/EditListingDescriptionPageFour';
import EditListingDescriptionPageFive from './EditListingDescriptionPages/EditListingDescriptionPageFive';
import EditListingDescriptionPageSix from './EditListingDescriptionPages/EditListingDescriptionPageSix';
import EditListingDescriptionPageSeven from './EditListingDescriptionPages/EditListingDescriptionPageSeven';
import EditListingDescriptionPageEight from './EditListingDescriptionPages/EditListingDescriptionPageEight';
import {
    PageTracker,
    BottomNavigation,
    BottomSeperator,
} from '../../components/EditListingWizard/Components';
import css from './EditListingDescriptionForm.css';
import OptionalBottomNavButtons from '../EditListingPhotosForm/OptionalBottomNavButtons';

const EditListingDescriptionRiderForm = ({
    currentStep,
    currentListing,
    isNewListingFlow,
    setCurrentFormInstance,
    isOfflineFlow,
    ...rest
}) => (
    <UnsavedChangesWrapper>
        <FinalForm
            {...rest}
            mutators={{ ...arrayMutators }}
            keepDirtyOnReinitialize
            render={fieldRenderProps => {
                const {
                    className,
                    disabled,
                    handleSubmit,
                    invalid,
                    updateInProgress,
                    fetchErrors,
                    form,
                    values,
                    tabParams,
                    handleStepChange,
                } = fieldRenderProps;

                const { starredDisciplines } = values;
                const noStarredDisciplinesSelected =
                    !starredDisciplines || starredDisciplines.length === 0;

                const { updateListingError, createListingDraftError, showListingsError } =
                    fetchErrors || {};
                const errorMessageUpdateListing = updateListingError ? (
                    <p className={css.error}>
                        <FormattedMessage id="EditListingDescriptionForm.updateFailed" />
                    </p>
                ) : null;

                // This error happens only on first tab (of EditListingWizard)
                const errorMessageCreateListingDraft = createListingDraftError ? (
                    <p className={css.error}>
                        <FormattedMessage id="EditListingDescriptionForm.createListingDraftError" />
                    </p>
                ) : null;

                const errorMessageShowListing = showListingsError ? (
                    <p className={css.error}>
                        <FormattedMessage id="EditListingDescriptionForm.showListingFailed" />
                    </p>
                ) : null;

                const classes = classNames(css.root, className);
                // const submitReady = updated && pristine;
                const submitInProgress = updateInProgress;
                const submitDisabled =
                    invalid ||
                    disabled ||
                    submitInProgress ||
                    (currentStep === 6 && noStarredDisciplinesSelected);

                const showPreviewListingBtn =
                    currentListing && currentListing.id && isNewListingFlow;
                const { allStepsCount } = tabParams;

                const commonProps = { form, values: values || {} };

                return (
                    <Form className={classes} onSubmit={handleSubmit}>
                        {errorMessageCreateListingDraft}
                        {errorMessageUpdateListing}
                        {errorMessageShowListing}

                        <FormSpy
                            onChange={formState => {
                                setCurrentFormInstance({
                                    values: formState.values,
                                    valid: formState.valid,
                                    dirty: formState.dirty,
                                    handleSubmit: rest.onSubmit,
                                });
                            }}
                            subscription={{ values: true, dirty: true, valid: true }}
                        />

                        <PageTracker
                            allStepsCount={allStepsCount}
                            currentStep={currentStep}
                            titleMsgId="EditListingDescriptionForm.pagesTitle"
                        />

                        {currentStep === 1 && <EditListingDescriptionPageOne {...commonProps} />}

                        {currentStep === 2 && <EditListingDescriptionPageTwo {...commonProps} />}

                        {currentStep === 3 && <EditListingDescriptionPageThree {...commonProps} />}

                        {currentStep === 4 && <EditListingDescriptionPageFour {...commonProps} />}

                        {currentStep === 5 && <EditListingDescriptionPageFive {...commonProps} />}

                        {currentStep === 6 && <EditListingDescriptionPageSix {...commonProps} />}

                        {currentStep === 7 && (
                            <EditListingDescriptionPageSeven
                                {...commonProps}
                                currentListing={currentListing}
                            />
                        )}

                        {currentStep === 8 && (
                            <EditListingDescriptionPageEight {...fieldRenderProps} />
                        )}

                        <BottomSeperator showPreviewListingBtn={showPreviewListingBtn} />

                        <BottomNavigation
                            allStepsCount={allStepsCount}
                            currentStep={currentStep}
                            tabNum={1}
                            handleStepChange={handleStepChange}
                            isOfflineFlow={isOfflineFlow}
                            submitInProgress={submitInProgress}
                            submitDisabled={submitDisabled}
                            values={values}
                            currentListing={currentListing}
                            isNewListingFlow={isNewListingFlow}
                            showPreviewListingBtn={showPreviewListingBtn}
                            onSubmit={rest.onSubmit}
                            customButtons={
                                currentStep === 8 && isNewListingFlow
                                    ? ({ handleOnNextStep }) => (
                                          <OptionalBottomNavButtons
                                              pristine={Boolean(
                                                  values?.skillsGeneral?.length ||
                                                      values?.skillsExperience?.length
                                              )}
                                              type={isOfflineFlow ? 'button' : 'submit'}
                                              inProgress={submitInProgress}
                                              disabled={submitDisabled}
                                              onClick={() => {
                                                  if (isOfflineFlow) {
                                                      const tabNum = 1;
                                                      handleOnNextStep(
                                                          tabNum,
                                                          allStepsCount == currentStep
                                                      );
                                                  }
                                              }}
                                              goBack={() =>
                                                  handleStepChange({
                                                      action: 'previous',
                                                      tabNum: 1,
                                                  })
                                              }
                                          />
                                      )
                                    : null
                            }
                        />
                    </Form>
                );
            }}
        />
    </UnsavedChangesWrapper>
);

export default EditListingDescriptionRiderForm;
